module.exports = __webpack_public_path__ + "static/media/wordpress.ca7536f5.png";